{
  "restoredMessage": "Restaurado \"{{manufacturer}} {{model}}\"",
  "restoreError": "No se pudo restaurar. Intenta de nuevo.",
  "emptyState": "No hay tipos FAA en lista negra. Usa el botón \"Ignorar\" en la pestaña Mapeo de aeronaves para excluir tipos de aeronaves irrelevantes (drones, globos, etc.)",
  "headers": {
    "manufacturer": "Fabricante FAA",
    "model": "Modelo FAA",
    "restore": "Restaurar"
  },
  "restoreTooltip": "Restaurar este tipo FAA a la pestaña Mapeo de Aeronaves"
}
